import React from 'react';
import { Flame, Users, Trash2, Target, Trophy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DEMO } from '../constants/mockData';

export const ImpactPage = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-bold text-white">Impact Dashboard</h1>
      <p className="text-text-secondary text-sm">Track the collective impact of the BURNZ community</p>
    </div>
    
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {[
        { label: "NFTs Dumped", value: DEMO.stats.total_nfts_dumped, icon: Flame, color: "var(--burnz-orange)" },
        { label: "Users", value: DEMO.stats.total_users, icon: Users, color: "var(--burnz-purple)" },
        { label: "BURNZ Burned", value: DEMO.stats.total_burnz_burned, icon: Trash2, color: "var(--burnz-red)" },
        { label: "Quests Done", value: DEMO.stats.total_quest_completions, icon: Target, color: "var(--burnz-green)" }
      ].map((stat, i) => (
        <Card key={i} className="bg-surface-2 border-white/5">
          <CardContent className="p-6 text-center">
            <stat.icon className="w-10 h-10 mx-auto mb-3" style={{ color: stat.color }} />
            <p className="text-3xl font-bold text-white">{stat.value?.toLocaleString()}</p>
            <p className="text-text-secondary">{stat.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
    
    <Card className="bg-surface-2 border-white/5">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <Trophy className="w-5 h-5 text-yellow-400" />
          Leaderboard
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {DEMO.leaderboard.map((entry, i) => (
          <div 
            key={i} 
            className={`flex items-center gap-4 p-4 rounded-xl ${
              i === 0 ? "bg-yellow-500/10" : 
              i === 1 ? "bg-gray-400/10" : 
              i === 2 ? "bg-amber-600/10" : 
              "bg-white/5"
            }`}
          >
            <div 
              className={`w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold ${
                i === 0 ? "bg-yellow-500 text-black" : 
                i === 1 ? "bg-gray-300 text-black" : 
                i === 2 ? "bg-amber-600 text-white" : 
                "bg-white/10 text-white"
              }`}
            >
              {entry.rank}
            </div>
            <span className="text-2xl">{entry.avatar}</span>
            <div className="flex-1">
              <p className="text-white font-semibold">{entry.name}</p>
              <p className="text-text-muted text-sm">{entry.level}</p>
            </div>
            <p className="text-2xl font-bold text-primary-theme">{entry.xp.toLocaleString()}</p>
          </div>
        ))}
      </CardContent>
    </Card>
  </div>
);

export default ImpactPage;
